import React from "react";
import { Divider } from "@material-ui/core";

const ValidationCodeInput = ({
  loginMethod,
  handleChangeLoginMethods,
  formik,
}) => {
  const handleInputChange = (e) => {
    const value = e.target.value;
    // Only allow digits
    if (/^\d*$/.test(value)) {
      formik.setFieldValue("validationCode", value);

      // Auto-submit when 6 digits are entered
      if (value.length === 6) {
        setTimeout(() => {
          formik.handleSubmit();
        }, 300);
      }
    }
  };

  const handleInputPaste = (e) => {
    e.preventDefault(); // Prevent default paste behavior

    // Handle paste event for autofill
    const pastedData = e.clipboardData.getData("text");
    const cleanedData = pastedData.replace(/\D/g, "").substring(0, 6);

    formik.setFieldValue("validationCode", cleanedData);

    // Auto-submit if we have 6 digits
    if (cleanedData.length === 6) {
      setTimeout(() => {
        formik.handleSubmit();
      }, 300);
    }
  };

  return (
    <div className="fv-plugins-icon-container mt-4">
      <div
        className="text-center text-muted mb-2"
        onClick={handleChangeLoginMethods}
      >
        {loginMethod === "email" ? (
          <span>
            If you did not receive an email, try using your{" "}
            <u style={{ cursor: "pointer" }}>phone number</u>.
          </span>
        ) : (
          <span>
            If you did not receive an sms, try using your{" "}
            <u style={{ cursor: "pointer" }}>email</u>.
          </span>
        )}
      </div>
      <Divider />
      <input
        placeholder="Validation Code"
        type="tel"
        className="form-control form-control-solid h-auto py-5 px-6 mt-4"
        name="validationCode"
        value={formik.values.validationCode}
        onChange={handleInputChange}
        onPaste={handleInputPaste}
      />
      {formik.touched.validationCode && formik.errors.validationCode && (
        <div className="fv-help-block text-center">
          {formik.errors.validationCode}
        </div>
      )}
    </div>
  );
};

export default ValidationCodeInput;
